export const COURSE_TYPE = {
  Normal: 'normal',
  Video: 'video'
}

export const COURSE_EXTRA_TIME = {
  EarlyTime: 60 * 1000 * 10,
  ExtendTime: 60 * 1000 * 90
}